module.exports = __webpack_public_path__ + "static/accounts_vault_1-a345198d9535887c0fa7be8e03b797f5.png";